<template>
    <div class="sort-box">
        <div class="sort-content">
            <div @click="chooseSort(0)">
                <span :class="sort==0&&'active'">综合排序</span>
                <img 
                    src="@/assets/hotel/img/home/right_cg.png" 
                    alt="right"
                    v-show="sort==0"
                >
            </div>
            <div @click="chooseSort(1)">
                <span :class="sort==1&&'active'">评分高优先</span>
                <img 
                    src="@/assets/hotel/img/home/right_cg.png" 
                    alt="right"
                    v-show="sort==1"
                >
            </div>
            <div @click="chooseSort(2)">
                <span :class="sort==2&&'active'">销量高优先</span>
                <img 
                    src="@/assets/hotel/img/home/right_cg.png" 
                    alt="right"
                    v-show="sort==2"
                >
            </div>
            <div @click="chooseSort(3)">
                <span :class="sort==3&&'active'">价格低→高</span>
                <img 
                    src="@/assets/hotel/img/home/right_cg.png" 
                    alt="right"
                    v-show="sort==3"
                >
            </div>
            <div @click="chooseSort(4)">
                <span :class="sort==4&&'active'">价格高→低</span>
                <img 
                    src="@/assets/hotel/img/home/right_cg.png" 
                    alt="right"
                    v-show="sort==4"
                >
            </div>
            <div @click="chooseSort(5)">
                <span :class="sort==5&&'active'">距离近→远</span>
                <img 
                    src="@/assets/hotel/img/home/right_cg.png" 
                    alt="right"
                    v-show="sort==5"
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'
    export default {
        data() {
            return {
                sort:0,//激活
            }
        },
        computed:{
            ...mapState({
                sortActive:state => state.hotel.sortActive,
            })
        },
        created() {
            if(this.sortActive){
                this.sort = this.sortActive
            }
        },
        methods: {
            ...mapMutations(['setState']),
            chooseSort(idx){//选择
                this.sort = idx;
            },
            confirm(){//确认
                this.setState([{name:'sortActive',value:this.sort}]);
                let formDataParams = {};
                switch(this.sort){
                    case 0:
                        formDataParams = {name:'综合排序',value:'complex'};
                        break;
                    case 1:
                        formDataParams = {name:'评分高优先',value:'ratings'};
                        break;
                    case 2:
                        formDataParams = {name:'销量高优先',value:'sales_desc'};
                        break;
                    case 3:
                        formDataParams = {name:'价格低→高',value:'price_asc'};
                        break;
                    case 4:
                        formDataParams = {name:'价格高→低',value:'price_desc'};
                        break;
                    case 5:
                        formDataParams = {name:'距离近→远',value:'distence'};
                        break;
                }
                return formDataParams;
            },
            reset(){//重置
                this.sort = 0;
                this.setState([{name:'sortActive',value:0}]);
            }
        },
    }
</script>

<style lang="less" scoped>
    .sort-box{
        .sort-content{
            padding: 1rem 0;
            margin: 0 1.8rem 0 2rem;
            position: relative;
            >div{
                padding: 1rem 0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                span{
                    font-size: 1.5rem;
                    font-weight: 400;
                    line-height: 2.1rem;
                    color: #333333;
                    &.active{
                        color: #108B30;
                    }
                }
                img{
                    width: 1.8rem;
                    height: 1.7rem;
                }
            }
        }
    }
</style>